module.exports = __webpack_public_path__ + "img/header.e017b5cc.png";